module.exports = __webpack_public_path__ + "media/src/public/img/rutube_icon-6198dd4955693bc1387928e244dea946.svg";